"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrsaIconColorVarName = void 0;
const getUrsaIconColorVarName = () => `--sds--ursa-icons--text-color`;
exports.getUrsaIconColorVarName = getUrsaIconColorVarName;
//# sourceMappingURL=getUrsaIconColorVarName.js.map